<template>
  <label
    :for="id"
    class="app-checkbox-label">
    <input
      :id="id"
      :checked="checked"
      type="checkbox"
      class="d-none"
      @change="onChange">
    <b-icon-check2
      class="app-checkbox-label-icon"
      :class="{'app-checkbox-label-icon--checked': checked}" />
    <span>
      <slot />
    </span>
  </label>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    onChange(v) {
      this.$emit('input', v.target.checked)
    },
  },
}
</script>

<style lang="scss" scoped>
.app-checkbox-label {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  color: white;
  cursor: pointer;

  & > span {
    color: $grey05;
  }

  // チェックボックスの枠内
  &::before {
    content: "";
    width: 20px;
    height: 20px;
    margin-right: 8px;
    border: 1px solid $grey05;
    border-radius: 50%;
    pointer-events: none;
  }
}

.app-checkbox-label-icon {
  position: absolute;
  width: 20px;
  height: 20px;
  background: no-repeat 50% / 50% 50%;
  padding: 2px;
  color: $grey05;
  &--checked {
    color: $l-blue;
  }
}
</style>
